import { render } from "./client-reboot-modal.vue?vue&type=template&id=87f2fe42&scoped=true&ts=true"
import script from "./client-reboot-modal.vue?vue&type=script&lang=ts"
export * from "./client-reboot-modal.vue?vue&type=script&lang=ts"

import "./client-reboot-modal.vue?vue&type=style&index=0&id=87f2fe42&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87f2fe42"]])

export default __exports__